export const enum LockIcon {
    LOCK = 'lock',
    LOCK_OPEN = 'lock_open'
}